import type { ReactNode } from "react";

import { createContext, useContext, useMemo, useState } from "react";

interface IOffcanvasContext {
  show: boolean;
  open: () => void;
  close: () => void;
}

interface IOffcanvasProviderProps {
  children: ReactNode;
}

const OffcanvasContext = createContext<IOffcanvasContext | undefined>(
  undefined
);

export const OffcanvasProvider = ({ children }: IOffcanvasProviderProps) => {
  const [show, setShow] = useState(false);

  const value = useMemo(
    () => ({
      show,
      open: () => setShow(true),
      close: () => setShow(false),
    }),
    [show]
  );

  return (
    <OffcanvasContext.Provider value={value}>
      {children}
    </OffcanvasContext.Provider>
  );
};

export const useOffcanvas = () => {
  const context = useContext(OffcanvasContext);

  if (!context) {
    throw new Error("useOffcanvas must be used within OffcanvasProvider");
  }
  return context;
};
